import { useCallback } from 'react';
import type { MarketCategory } from 'shared/src/api/marketService/getMarketCategories';
import { useLogMarketAnalyticsEvent } from '../../../hooks/useLogMarketAnalyticsEvent';

export const useLogApplyCategoryChipFilter = () => {
  const logMarketAnalytics = useLogMarketAnalyticsEvent();

  return useCallback<(category: MarketCategory, depth?: number) => void>(
    (category, depth = 0) => {
      logMarketAnalytics({
        name: 'APPLY_CATEGORY_CHIP_FILTER',
        channel: ['firebase', 'facebook', 'amplitude', 'braze', 'ablylog'],
        analytics: {
          CATEGORY_SNO: category.sno.toString(),
          CATEGORY_NAME: category.name,
          CATEGORY_DEPTH: depth,
        },
      });
    },
    [logMarketAnalytics],
  );
};
